import { ASSISTED_TRANSFER, REDUCERS} from '../../constants.js';

const initialUserState = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  currentState : ""
}

const assistedTransfer = (state = initialUserState, action) => {
  state = initialUserState;
  if(action.type === ASSISTED_TRANSFER.CHANGE_STATE ){
    return { currentState : action.currentState};
  }
  else{
    return state;
  }
}

export default assistedTransfer;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_assisted_transfer.js